export const recursiveSetTimeout = (fn, timeout) => {
  let timerId = setTimeout(async function run() {
    await fn();
    timerId = setTimeout(run, timeout);
  }, timeout);
  return timerId;
};
